import React from "react";
import { Button, Table } from "reactstrap";
import oroLogo from "../assets/images/oroLogo.png";
import SuccessFailureScreen from "./SuccessFailureScreen";

export default function PaymentDetailsSecond(props) {
  return (
    <div className="pdf-table">
      <div className="header">
        <div>
          <img src={oroLogo} alt="oro-logo" />
        </div>
        <p>Deal Confirmation</p>
      </div>
      <div className="header-bottom" />
      <div className="table-main">
        <p>
          <span className="font-weight-semi-bold">
            SUBJECT TO RECEIPT OF THE CONSIDERATION AMOUNT
          </span>{" "}
          mentioned below, ALPHA FINTECH PRIVATE LIMITED, do hereby agree to
          transfer the below mentioned securities to the Investor account, as
          per the details provided below.
        </p>
        <Table bordered>
          <tr>
            <td className="font-weight-semi-bold">Issuer</td>
            <td className="font-weight-semi-bold">ISIN</td>
            <td className="font-weight-semi-bold">Security Details</td>
            <td className="font-weight-semi-bold">Depository</td>
          </tr>
          <tr>
            <td>{props.issuer}</td>
            <td>{props.isin}</td>
            <td>{props.security}</td>
            <td>{props.depository}</td>
          </tr>
          <tr>
            <td className="font-weight-semi-bold">Face Value</td>
            <td className="font-weight-semi-bold">Interest payout frequency</td>
            <td className="font-weight-semi-bold" colSpan={2}>
              Debenture Trustee
            </td>
          </tr>
          <tr>
            <td>{props.faceVal}</td>
            <td>{props.freq}</td>
            <td colSpan={2}>Catalyst Trusteeship</td>
          </tr>
          <tr>
            <td className="font-weight-semi-bold">Face Value:</td>
            <td className="font-weight-semi-bold">
              Interest payout Frequency:
            </td>
            <td className="font-weight-semi-bold">Redemption start date:</td>
            <td className="font-weight-semi-bold">Maturity date:</td>
          </tr>
          <tr>
            <td>{props.faceVal}</td>
            <td>{props.freq}</td>
            <td>{props.startDate}</td>
            <td>{props.maturity}</td>
          </tr>
        </Table>
        <Table bordered>
          <tr>
            <td className="font-weight-semi-bold">Face Value:</td>
            <td className="font-weight-semi-bold">
              Interest payout Frequency:
            </td>
            <td className="font-weight-semi-bold">Redemption start date:</td>
            <td className="font-weight-semi-bold">Maturity date:</td>
          </tr>
          <tr>
            <td>{props.faceVal}</td>
            <td>{props.freq}</td>
            <td>{props.startDate}</td>
            <td>{props.maturity}</td>
          </tr>
        </Table>
      </div>
      <SuccessFailureScreen
        isSigned={props.isSigned}
        openScreen={props.openScreen}
        toggleScreen={props.toggleScreen}
      />
    </div>
  );
}
